import {AfterViewInit, Component} from '@angular/core';

@Component({
  selector: 'app-tama-landing',
  templateUrl: './tama-landing.component.html',
  styleUrls: ['./tama-landing.component.css']
})
export class TamaLandingComponent implements AfterViewInit {

    activeInfo = 'WHY_TAMA';

    today = new Date();

    ngAfterViewInit() {
        // Intersection Observer for scroll animations
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.15 });

        document.querySelectorAll('.fade-up, .slide-right, .scale-in').forEach(el => {
            observer.observe(el);
        });

        // Animated counter for Alerts
        function animateCount(el, target, duration) {
            let start = 0;
            const step = (timestamp) => {
                if (!start) start = timestamp;
                const progress = Math.min((timestamp - start) / duration, 1);
                el.textContent = Math.floor(progress * target);
                if (progress < 1) requestAnimationFrame(step);
            };
            requestAnimationFrame(step);
        }

        // Animated percentage
        function animatePercent(el, target, duration) {
            let start = 0;
            const step = (timestamp) => {
                if (!start) start = timestamp;
                const progress = Math.min((timestamp - start) / duration, 1);
                el.textContent = '+' + (progress * target).toFixed(1) + '%';
                if (progress < 1) requestAnimationFrame(step);
            };
            requestAnimationFrame(step);
        }

        // Trigger counters when cards become visible
        const alertCard = document.querySelector('.card-alerts');
        const officerCard = document.querySelector('.card-officers');

        const counterObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (entry.target === alertCard) {
                        animateCount(document.getElementById('alertCount'), 23, 1200);
                    }
                    if (entry.target === officerCard) {
                        animatePercent(document.getElementById('officerPercent'), 80.9, 1400);
                        setTimeout(() => {
                            document.getElementById('progressFill').style.width = '65.5%';
                        }, 300);
                    }
                    counterObserver.unobserve(entry.target);
                }
            });
        }, { threshold: 0.3 });

        counterObserver.observe(alertCard);
        counterObserver.observe(officerCard);
    }

}
